<div *ngIf="loader" class="spinner">
  <nx-spinner nxSize="large"></nx-spinner>
</div>
<div *ngIf="!loader && dataLoaded">
  <div nxRow class="position">
    <div nxCol="10">
    </div>
    <div nxCol="2">
      <button [disabled]="myMap.size === 0" nxButton="primary small" (click)="openSimilarSearch()"  type="button" class="my-search-button">Suche mit Beispiel</button>
    </div>
  </div>
  <app-metadata-form [documentMetadata]="documentMetadata" [myMap]="myMap" [showCheckbox]="showCheckbox" [update]="update"></app-metadata-form>

  <div nxRow class="position">
    <div nxCol="2">
      <button [disabled]="update" nxButton="primary small" (click)="setUpdate()" class="my-search-button" type="button">Index ändern</button>
    </div>

    <div  nxCol="2">
      <button [disabled]="!update" nxButton="primary small" (click)="callBackend()" class="my-search-button" type="button">Aktualisieren</button>
    </div>

    <div nxCol="2">
      <button nxButton="primary small" (click)="openDocument()"  type="button" class="my-search-button">Öffnen</button>
    </div>

    <div nxCol="2">
      <button nxButton="primary small" (click)="importSimilar()"  type="button" class="my-search-button">Ähnlicher Import</button>
    </div>

    <div nxCol="2">
      <button [disabled]="!update" nxButton="primary small" (click)="reset()"  type="button" class="my-search-button">Zurücksetzen</button>
    </div>

    <div nxCol="2">
      <button nxButton="primary small" (click)="generateSearchLink()"  type="button" class="my-search-button">E-Mail einen Link</button>
    </div>
  </div>
</div>
